import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import CuratedTripsItemTile from './CuratedTripsItemTile/CuratedTripsItemTile'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { EmptyArray } from 'lib/array/arrayUtils'
import { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  curatedTrips: Array<BasicTrip>
  id?: string
}

const Container = styled.section`
  position: relative;
  padding: ${rem(60)} 0 0 0;

  &:target {
    scroll-behavior: smooth;
    scroll-snap-align: start;
  }
`

export const TripPanelGrid = styled.div`
  display: grid;
  column-gap: ${rem(20)};
  row-gap: ${rem(48)};
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 1fr);
    justify-items: stretch;
    align-items: stretch;
  }

  ${mediaQueryUp.largeDesktop} {
    grid-template-columns: repeat(3, 1fr);
    column-gap: ${rem(20)};
    row-gap: ${rem(48)};
  }
`

export default function CuratedTripsListGrid({
  curatedTrips = EmptyArray,
  id,
  children,
}: PropsWithChildren<Props>) {
  return (
    <Container id={id}>
      <VerticalSpacer gap={32}>
        <VerticalSpacer gap={16}>
          <VerticalSpacer gap={8}>
            <Heading variant="heading3" style={{ gridArea: 'title' }}>
              Explore all <i>curated</i> trips
            </Heading>
          </VerticalSpacer>
          <TripPanelGrid>
            {curatedTrips.map((trip) => (
              <CuratedTripsItemTile
                key={trip.id}
                trip={trip}
                showDescription
                showCTA
              />
            ))}
          </TripPanelGrid>
        </VerticalSpacer>
        {children}
      </VerticalSpacer>
    </Container>
  )
}
